module.exports = __webpack_public_path__ + "media/111.71333655.wav";